export { default } from './PrivateNoteInfo';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/PrivateNoteInfo/index.js